import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router';
import dynamic from 'next/dynamic';
import Cookies from 'js-cookie';

import {useApp} from '@context/AppProvider';
import Listing from '@components/product/list';
import styles from '@styles/listing.module.scss';
import SeoMeta from '@components/common/seo';
import {api} from '@utils/api';
const AgeValidatorModal = dynamic(() => import('@models/ageValidator.modal'));
import Loading from '@components/Loading';
import {ageVerified} from '@utils/functions';

function ProductList(props) {
	const router = useRouter();
	const {
		idb: {isoCode, showRegisterPop},
		setIdb,
	} = useApp();

	const [data, setData] = useState({
		isModalShow: false,
		listLoad: false,
		isoCode: null,
		showRegisterPop: false,
	});

	const {slug, ...filters} = router.query;
	let store = null,
		category = null;
	if (slug.length === 1) {
		store = slug[0];
	} else if (slug.length === 2) {
		store = slug[0];
		category = slug[1];
	} else {
		throw Error();
	}

	useEffect(() => {
		const init = () => {
			let obj = {};
			if (
				isoCode.toLowerCase() === 'nz' &&
				props?.retailer?.storeDetail?.licenseNumber
			) {
				obj = {
					isModalShow: true,
					listLoad: true,
				};
			} else {
				obj = {
					isModalShow: false,
					listLoad: true,
				};
			}
			setData(preState => ({
				...preState,
				...obj,
			}));
		};

		if (isoCode && !data.listLoad && !showRegisterPop) {
			init();
		}
	}, [
		isoCode,
		data.listLoad,
		props?.retailer?.storeDetail?.licenseNumber,
		showRegisterPop,
	]);

	useEffect(() => {
		if (
			isoCode !== null &&
			!Cookies.get('isoCode') &&
			isoCode.toLowerCase() !== data?.isoCode?.toLowerCase()
		) {
			setData(preState => ({
				...preState,
				listLoad: false,
				isoCode: isoCode,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isoCode]);

	useEffect(() => {
		if (showRegisterPop && isoCode) {
			let obj = {};
			if (isoCode.toLowerCase() === 'nz' && !ageVerified()) {
				setTimeout(() => {
					setIdb(val => ({...val, showRegisterPop: false}));
				}, 3000);
				obj = {
					showRegisterPop: true,
				};
			} else {
				obj = {
					isModalShow: false,
					listLoad: true,
				};
			}
			setData(preState => ({
				...preState,
				...obj,
			}));
		}
	}, [isoCode, setIdb, showRegisterPop]);

	if (!data.isModalShow && !data.listLoad) {
		return <Loading />;
	}

	return (
		<div className={styles.listingPageBlock}>
			<SeoMeta
				title={`${props.retailer.shop_name} | Online Store | Better That`}
				url={router.asPath}
				description={`Shop ${props.retailer.shop_name} store online at Better That and support Good Causes every time you buy. It's shopping- but Better!`}
				keywords={`Buy ${props.retailer.shop_name} store online`}
			/>
			{data.listLoad &&
				(data.isModalShow ? (
					<AgeValidatorModal
						callback={() => {
							if (data.showRegisterPop) {
								setIdb(val => ({...val, showRegisterPop: true}));
							}

							setData(preState => ({
								...preState,
								isModalShow: false,
								showRegisterPop: false,
							}));
						}}
					/>
				) : (
					<Listing
						styles={styles}
						filters={filters}
						store={store}
						category={category}
						retailer={props.retailer}
						retailerId={props.retailer._id}
						storeName={props.retailer.shop_name}
					/>
				))}
			{/* <div className='container'>
				<div className='row'>
					<div
						className={`${styles.storeInformation}  col-sm-12 text-center mb-50`}
					>
						<h2 className={styles.intoHeading}>
							About {props?.retailer?.shop_name}
						</h2>
						<p className={styles.description}>{props?.retailer?.shop_desc}</p>
					</div>
				</div>
			</div> */}
		</div>
	);
}

export async function getServerSideProps(ctx) {
	ctx.res.setHeader(
		'Cache-Control',
		'public, s-maxage=10, stale-while-revalidate=59',
	);
	const data = await api(
		{
			url: `/retailer/${ctx.query.slug[0]}`,
			method: 'POST',
			data: {slug: ctx.query.slug[0]},
		},
		ctx,
	);
	console.log(data);
	return {
		props: {
			retailer: data.retailer || {},
		},
	};
}

ProductList.Layout = true;

export default ProductList;
